'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import unescapedText from 'I18n/utils/unescapedText';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIButton from 'UIComponents/button/UIButton';
import UIProgress from 'UIComponents/progress/UIProgress';
import { SLINKY, MARIGOLD } from 'HubStyleTokens/colors';
import * as LIST_QUERIES from '../../constants/reviews/ReviewsListQueries';
import ReviewStats from '../../records/ReviewStats';
import { FILTER_KEY } from '../../constants/reviews/ReviewsListQueries';
const Number = styled.span.withConfig({
  displayName: "OverallDistribution__Number",
  componentId: "wh4wkg-0"
})(["font-size:12px;font-weight:600;"]);
const Progress = styled(UIProgress).withConfig({
  displayName: "OverallDistribution__Progress",
  componentId: "wh4wkg-1"
})(["max-height:12px;width:150px;"]);

const OverallDistribution = ({
  className,
  reviewStats,
  onUpdateFilters,
  heading
}) => {
  const percentages = reviewStats.getOverallPercentages().toJS();
  const validFilters = useMemo(() => reviewStats.getValidRatingFilters(), [reviewStats]);

  const renderRatingRow = (stars, value) => {
    // e.g THREE_STARS, ONE_STAR, etc.
    const stateValue = LIST_QUERIES.STAR_NUM_TO_STATE.get(stars);
    const isDisabledValue = !validFilters.has(stateValue);

    const onClick = () => onUpdateFilters({
      textKey: FILTER_KEY,
      value: stateValue,
      source: 'overall distribution'
    });

    return /*#__PURE__*/_jsxs(UIFlex, {
      style: {
        lineHeight: '20px'
      },
      className: "m-bottom-0",
      align: "center",
      children: [/*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsxs(UIButton, {
          use: "link",
          onClick: onClick,
          disabled: isDisabledValue,
          children: [/*#__PURE__*/_jsx(Number, {
            children: stars
          }), /*#__PURE__*/_jsx(UIIcon, {
            className: "m-x-1",
            name: "favorite",
            color: MARIGOLD,
            size: "xxs"
          })]
        })
      }), /*#__PURE__*/_jsx("span", {
        className: "m-right-2 display-inline-block",
        children: /*#__PURE__*/_jsx(Progress, {
          "aria-label": unescapedText('ecosystemMarketplaceCore.reviews.overallDistributionAccessibleName', {
            value,
            rating: stars
          }),
          style: {
            background: SLINKY
          },
          wrapperClassName: "m-bottom-0",
          value: value
        })
      }), /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "link",
          onClick: onClick,
          disabled: isDisabledValue,
          children: /*#__PURE__*/_jsx(Number, {
            children: /*#__PURE__*/_jsx(FormattedPercentage, {
              value: value
            })
          })
        })
      })]
    }, stars);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [/*#__PURE__*/_jsx("span", {
      className: "is--heading-7 m-bottom-2",
      children: heading || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystemMarketplaceCore.reviews.overallDistribution"
      })
    }), Object.keys(percentages).reverse().map(star => renderRatingRow(star, percentages[star]))]
  });
};

OverallDistribution.propTypes = {
  className: PropTypes.string,
  reviewStats: PropTypes.instanceOf(ReviewStats).isRequired,
  onUpdateFilters: PropTypes.func.isRequired,
  heading: PropTypes.node
};
export default OverallDistribution;